module.exports = __webpack_public_path__ + "img/as.asb326528.svg";